// extracted by mini-css-extract-plugin
module.exports = {"navTab":"NavTab_navTab__BeWMg","navCont":"NavTab_navCont__3022v"};